import './fireworkAnimation.css';

export default function FireworkAnimation() {
    return (
        <div className="w-full h-full">
            <div class="firework"></div>
            <div class="firework"></div>
            <div class="firework"></div>
        </div>
    )
}